import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export { generateICS, downloadICS } from './utils/generateICS';

/**
 * Merge arbitrary class names and resolve Tailwind CSS class conflicts.
 *
 * @param {...ClassValue[]} classes - Class values including strings, arrays of strings, or objects with keys as class names and truthy values.
 * @returns {string} A single, merged className string.
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(...classes));
}
